import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactSalesLinkComponent } from './contact-sales-link/contact-sales-link.component';
import { SharedModule } from '@nk/shared/shared.module';
import { ButtonDirective } from '@nk/ui-lib';

@NgModule({
  declarations: [ContactSalesLinkComponent],
  imports: [CommonModule, SharedModule, ButtonDirective],
  exports: [ContactSalesLinkComponent],
})
export class ContactSalesModule {}
